<div id="main" class="d-flex flex-column justify-content-center">
  <div
    class="row d-flex align-items-start justify-content-center content-step-bar"
  >
    <div class="col-6 col-sm-4">
      <app-progress-step-bar-with-number
        [steps]="steps"
      ></app-progress-step-bar-with-number>
    </div>
  </div>

  <form [formGroup]="formGroup" novalidate>
    <div class="row d-flex justify-content-center">
      <div class="col-12 col-sm-7 col-lg-6 content-message">
        <app-content-message
          [icon]=""
          [title]="title"
          [description]="description"
        >
        </app-content-message>

        <div class="h-14-px"></div>

        <div
          class="w-100 d-flex justify-content-center"
          *ngIf="!isPreloadedPayrollCheck"
        >
          <div class="w-85">
            <app-form-file-input-drag
              #fileInputDrag
              [title]="'Desprendible de pago'"
              [fieldControl]="formGroup.controls['filePayrollCheck']"
              [fileInputId]="'file-input_customer-payrollcheck'"
              (fileUploadEvent)="
                fileUpload(
                  $event,
                  fileInputDrag,
                  documentTypeTapEnum.PAYROLLCHECK
                )
              "
              (fileInputCompleteEvent)="
                fileInputComplete(
                  fileInputDrag,
                  documentTypeTapEnum.PAYROLLCHECK
                )
              "
              [observable]="observableUploadFile"
              [parentForm]="formGroup"
              [progress]="progress.get(documentTypeTapEnum.PAYROLLCHECK)"
            ></app-form-file-input-drag>
          </div>
        </div>

        <ng-container
          *ngIf="isClientEducational && !isPreloadedLaborCertification"
        >
          <div class="h-14-px"></div>
          <div class="w-100 d-flex justify-content-center">
            <div class="w-85">
              <hr *ngIf="!isPreloadedPayrollCheck" />

              <app-form-file-input-drag
                #fileInputDragCertified
                [title]="'Certificado laboral del cliente'"
                [fieldControl]="formGroup.controls['fileCertified']"
                [fileInputId]="'fileCertified'"
                (fileUploadEvent)="
                  fileUpload(
                    $event,
                    fileInputDragCertified,
                    documentTypeTapEnum.LABOR_CERTIFICATION
                  )
                "
                (fileInputCompleteEvent)="
                  fileInputComplete(
                    fileInputDragCertified,
                    documentTypeTapEnum.LABOR_CERTIFICATION
                  )
                "
                [observable]="observableUploadFile"
                [parentForm]="formGroup"
                [progress]="
                  progress.get(documentTypeTapEnum.LABOR_CERTIFICATION)
                "
              ></app-form-file-input-drag>
            </div>
          </div>
        </ng-container>

        <div class="h-14-px"></div>

        <div class="w-100 h-110-px d-flex justify-content-center">
          <div class="container-button">
            <div class="container-center-button">
              <app-button
                id="app-button_button-click"
                [cssClass]="'w-100 buttonTextMedium'"
                [loading]="loadingUploadButton"
                [mandatory]="true"
                [text]="'Finalizar'"
                [parentForm]="formGroup"
                (clickEvent)="continue()"
              ></app-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<app-form-popup-message-box
  #formPopupMessageBox
  [messageBox]="messageBox"
  [messageEnum]="messageEnum"
  (closePopupEvent)="closeMessageBox()"
></app-form-popup-message-box>
